/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { decode } from 'he';

/**
 * Strip html tag from the content
 * @param {string} html - Current html content
 * @returns {string}
 */
const strip = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

const dateFormat = (date) => {
  const createdDate = new Date(date);

  const day = createdDate.getDate();
  const month = [];
  month[0] = 'Jan';
  month[1] = 'Feb';
  month[2] = 'Mar';
  month[3] = 'Apr';
  month[4] = 'May';
  month[5] = 'Jun';
  month[6] = 'Jul';
  month[7] = 'Aug';
  month[8] = 'Sep';
  month[9] = 'Oct';
  month[10] = 'Nov';
  month[11] = 'Dec';
  const year = createdDate.getFullYear();

  return `${day} ${month[createdDate.getMonth()]} ${year} `;
};

const buttonText = (entry) => {
  const postType = entry.subtype;

  if (postType === 'guides' || postType === 'guides-tech-hub') {
    return 'Read now';
  }

  if (postType === 'whitepapers' || postType === 'whitepapers-tech-hub') {
    return 'Read now';
  }

  if (postType === 'events') {
    return 'Sign up';
  }

  if (postType === 'webinars') {
    return 'Find out more';
  }

  return 'Read more';
};

const downloadSubtypes = [
  'applications',
  'planning-scenarios',
  'brochures',
  'documents',
  'guides',
  'guides-tech-hub',
  'whitepapers',
  'whitepapers-tech-hub',
];

const Result = ({ entry }) => (
  <div className="wp-block-deepsea-column col-desk-6 col-tab-6 col-mob-12">
    <article className="card-item" role="article" aria-label={decode(entry.title)}>
      <div className="card-item-content">
        <div className="card-itemTags">
          {entry.subtype && entry.subtype !== 'webinars' && (
            <span className="deepsea-tag tag--grey">{entry.subtype_name}</span>
          )}
          {entry.subtype && entry.subtype === 'webinars' && entry.webinar_name && (
            <span className="deepsea-tag tag--grey">{entry.webinar_name}</span>
          )}
          {entry.asset_class_name && <span className="deepsea-tag">{entry.asset_class_name}</span>}
          {entry.qualifications && (
            <span className="deepsea-tag tag--purple">{entry.qualifications}</span>
          )}
        </div>
        {entry.subtype !== 'people' && (
          <h4 className="card-itemTitle">
            <a href={entry.url}>{decode(entry.title)}</a>
          </h4>
        )}
        {entry.author !== '' && entry.author_posts_url && (
          <div className="card-itemAuthor">{`By ${entry.author}`}</div>
        )}
        {entry.subtype === 'people' && (
          <h3 className="card-itemTitle">
            <span>{decode(entry.title)}</span>
          </h3>
        )}
        {entry._embedded !== undefined && (
          <div className="card-itemExcerpt">
            <p>
              {entry._embedded.self[0].excerpt && strip(entry._embedded.self[0].excerpt.rendered)}
            </p>
          </div>
        )}
        {entry.excerpt !== undefined && (
          <div className="card-itemExcerpt">
            <p>{entry.excerpt && strip(entry.excerpt)}</p>
          </div>
        )}
        {entry.webinar_start !== undefined && entry.webinar_type !== 'on-demand' && (
          <div className="card-itemStart">
            <p>{entry.webinar_start && dateFormat(entry.webinar_start)}</p>
          </div>
        )}
        {entry.subtype !== 'people' && (
          <div className="card-itemButton">
            {downloadSubtypes.includes(entry.subtype) && entry.download_url ? (
              <div data-icon="download" className="is-style-icon">
                <a href={entry.url} target="_blank" className="btn btn--line wp-block-button__link">
                  Download
                </a>
              </div>
            ) : (
              <a href={entry.url} className="btn btn--line">
                {buttonText(entry)}
              </a>
            )}
          </div>
        )}
      </div>
    </article>
  </div>
);

export default Result;
